import { EVENT_DEBUG, eventLog, infoLog } from './general'

export const thumbsUpClick = (
  url: string,
  orderId?: string | string[] | undefined
) => {
  if (EVENT_DEBUG && !window?.dataLayer) {
    infoLog('Thumbsup Clicked: No Data Layer found.')
  }
  if (window?.dataLayer) {
    const detail = {
      event: 'Thumbsup Clicked',
      url: url,
      orderId: orderId,
    }
    window?.dataLayer?.push(detail)
    if (EVENT_DEBUG) eventLog(`Thumbsup Clicked (custom)`, { detail })
  }
}
